import { getUserInformation } from '@/helpers/auth.helper';
import { UserRoleEnum } from '@/types/auth.types';

export function useUserInformation() {
  const { role, name, userName, saleAreaId, organizationId } =
    getUserInformation();
  const isSbfMasterOrSbsOperationRole = [
    UserRoleEnum.sbf_master,
    UserRoleEnum.sbs_operation,
  ].includes(role!);
  const isSbsSaleOrSbsTagTeamRole = [
    UserRoleEnum.sbs_sales,
    UserRoleEnum.sbs_tag_team,
  ].includes(role!);
  const isChainRole = role === UserRoleEnum.organization;
  const isWeddingRole = role === UserRoleEnum.wedding;
  const isSbsRoles = isSbfMasterOrSbsOperationRole || isSbsSaleOrSbsTagTeamRole;
  const isSbfMasterRole = role === UserRoleEnum.sbf_master;

  return {
    name,
    role,
    userName,
    saleAreaId,
    organizationId,
    isSbsRoles,
    isSbfMasterOrSbsOperationRole,
    isSbsSaleOrSbsTagTeamRole,
    isChainRole,
    isWeddingRole,
    isSbfMasterRole,
  };
}
